module.exports = __webpack_public_path__ + "media/images/arrow-white-left-4c048e79.png";